import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AiPromptAudit } from '../../models/ai-assistant.models';

@Component({
  selector: 'app-audit-prompt-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './audit-prompt-dialog.component.html',
  styleUrl: './audit-prompt-dialog.component.css',
})
export class AuditPromptDialogComponent {
  @Input() audit: AiPromptAudit | null = null;
  @Output() closeRequested = new EventEmitter<void>();

  closeOnBackdrop(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.closeRequested.emit();
    }
  }
}
